/* Transform three fixed SVG curves, with no per-frame DOM writes. */
const movements = {
  wave: [
    ['translate(-22px, 5px) rotate(-1deg)', 'translate(22px, -12px) rotate(1deg)'],
    ['translate(18px, -10px) scaleY(.96)', 'translate(-18px, 12px) scaleY(1.04)'],
    ['translate(-12px, 12px) rotate(1deg)', 'translate(24px, -8px) rotate(-1deg)'],
  ],
  wave_soft: [
    ['translate(-30px, 9px) rotate(-1.4deg)', 'translate(30px, -18px) rotate(1.4deg)'],
    ['translate(25px, -15px) scaleY(.94)', 'translate(-25px, 17px) scaleY(1.06)'],
    ['translate(-18px, 18px) rotate(1.4deg)', 'translate(32px, -12px) rotate(-1.4deg)'],
  ],
  weave: [
    ['translate(-14px, -10px) rotate(-2deg)', 'translate(16px, 18px) rotate(2deg)'],
    ['translate(16px, 16px) rotate(2deg)', 'translate(-20px, -14px) rotate(-2deg)'],
    ['translate(-18px, 8px) scaleY(.94)', 'translate(22px, -16px) scaleY(1.06)'],
  ],
  orbit: [
    ['translate(-12px, -8px) rotate(-3deg)', 'translate(16px, 8px) rotate(3deg)'],
    ['translate(12px, 12px) rotate(2deg)', 'translate(-16px, -12px) rotate(-2deg)'],
    ['translate(-14px, 6px) rotate(-1.5deg)', 'translate(14px, -10px) rotate(1.5deg)'],
  ],
};

class KineaHeroLines extends HTMLElement {
  connectedCallback() {
    if (this.animations) return;
    const frames = movements[this.dataset.variant] || movements.wave;
    const duration = this.dataset.variant === 'wave_soft' ? 16000 : 18000;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.events = new AbortController();
    this.visible = false;
    this.animations = [...this.querySelectorAll('[data-strand]')].map((line, index) => {
      const [start, end] = frames[index];
      const animation = line.animate(
        [{ transform: start }, { transform: end }, { transform: start }],
        { duration: duration + index * 4000, iterations: Infinity, easing: 'ease-in-out' }
      );
      animation.pause();
      return animation;
    });
    this.sync = () => {
      for (const animation of this.animations) {
        if (this.motion.matches) {
          animation.pause();
          animation.currentTime = 0;
        } else if (this.visible && !document.hidden) animation.play();
        else animation.pause();
      }
    };
    this.motion.addEventListener('change', this.sync, { signal: this.events.signal });
    document.addEventListener('visibilitychange', this.sync, { signal: this.events.signal });
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.sync();
      });
      this.observer.observe(this.closest('section') || this);
    } else {
      this.visible = true;
    }
    this.sync();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.events?.abort();
    this.animations?.forEach((animation) => animation.cancel());
    this.animations = null;
  }
}

if (!customElements.get('kinea-hero-lines')) {
  customElements.define('kinea-hero-lines', KineaHeroLines);
}
